import moment from 'moment';
import { OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CancelActivitiesService } from './../services/cancel-activities.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CancellableActivityItem } from '../cancel-activities.types';
import { map, tap, takeWhile, BehaviorSubject } from 'rxjs';
import { Table } from 'primeng/table'
import { ConfirmationService, FilterService, SortEvent } from 'primeng/api';


@Component({
    templateUrl: './cancel-activities.component.html',
    standalone: false
})
export class CancelActivitiesComponent implements OnInit, OnDestroy {

  @ViewChild(Table) primeNgTable;

  totalRowsCount: number;
  filteredRowCount: number;
  last90Days: boolean;
  cancelInProgressSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  cancelInProgress: Observable<boolean> = this.cancelInProgressSubject.asObservable();

  cols: any[];

  private isAlive = true;
  activities$: Observable<CancellableActivityItem[]>;


  assignees: string[];
  filterSelected: boolean = false;

  selectedForms: CancellableActivityItem[] = [];

  private onlyUnique(value, index, self) {
    return self.indexOf(value) === index &&  value;
  }

  exportFunction = (evt) => {
    if (evt.field === 'DateCreated') {
      const d = (moment(new Date(evt.data)).format('DD MMM YYYY'));
      return d;
    };
    return evt.data;
  }
  export(): void {
    this.primeNgTable.exportCSV();

  }
  constructor(
    private confirmationService: ConfirmationService,
    private readonly cancelActivitiesService: CancelActivitiesService, private filterService: FilterService) { }
  ngOnDestroy(): void {
    this.isAlive = false;
  }

  /**
   * may need to be modified to take account of filtering
   */
  recordCount$() {
    return this.activities$.pipe(
      map(records => (records || []).length),
      tap(rc => {
        this.totalRowsCount = rc;
      }
      )
    );
  }

  refreshActivities() {
    this.cancelInProgressSubject.next(true);
    this.cancelActivitiesService.refreshActivities()
      .subscribe(x => this.cancelInProgressSubject.next(false));
  }

  ngOnInit(): void {

    this.activities$ = this.cancelActivitiesService.activities$.pipe( map( all=> {
      if ( this.filterSelected ){
        return all.filter( activity => this.selectedForms.find( a => a.FormRef === activity.FormRef) );
      } else {
        return all;
      }
    }));

    this.refreshActivities();

    // set default date filter
    this.activities$.pipe(takeWhile(() => this.isAlive), tap(() => {
      if (this.primeNgTable) {
        var d = new Date();
        d.setMonth(d.getMonth() - 3);
        this.primeNgTable.filters['DateCreated'] = [{ value: d, matchMode: "dateBefore", operator: "and" }];
      }

    })).subscribe();

    this.cols = [
      { field: 'FormRef', header: 'Form Ref'},
      { field: 'DateCreated', header: 'Date Created' },
      { field: 'ActivityName', header: 'Activity Name' },
      { field: 'ActivityDetails', header: 'Activity Details' },
      { field: 'Assignee', header: 'Assignee' },
      { field: 'Status', header: 'Status' }
    ];

  }

  customSort(event: SortEvent) {
    if (event.field == 'checkbox') {
      event.data.sort((data1, data2) => {
        let result = null;
        const data1SelectedIndex = this.selectedForms.findIndex(x => x.FormRef == data1.FormRef);
        const data2SelectedIndex = this.selectedForms.findIndex(x => x.FormRef == data2.FormRef);
        result = (data1SelectedIndex < data2SelectedIndex) ? -1 : (data1SelectedIndex > data2SelectedIndex) ? 1 : 0;

        return (event.order * result);
    });
    } else {
    event.data.sort((data1, data2) => {
        const value1 = data1[event.field];
        const value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string')
            result = value1.localeCompare(value2);
        else
            result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

        return (event.order * result);
    });
  }
}

  handleCancelForms() {
    if (this.selectedForms.length == 0) return;

    const msg = this.selectedForms.length > 1 ? 'forms' : 'form';
    this.confirmationService.confirm({
      message: `Are you sure you want to cancel the ${this.selectedForms.length} selected ${msg}?`,
      accept: () => {
        this.cancelInProgressSubject.next(true);
        this.cancelActivitiesService.cancelActivities(this.selectedForms.map(f => f.FormRef))
          .subscribe(t => this.refreshActivities() );
        this.selectedForms = [];
      }
    });
  }

  disableCancel() {
    return this.selectedForms.length == 0;
  }

  handleFilter(evt) {
    this.filteredRowCount = evt.filteredValue.length;
  }

  clear() {
    this.primeNgTable.clear();
  }

}
